import React, { useRef, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useJobCreation } from "./JobCreationContext";
import { window } from "mixpanel-browser/src/window";
import PreviewJobModal from "./JobPreviewModal";
import JobButtons from "./Job-Buttons";
import CreateJobLoadingOverlay from "./CreateJobLoadingOverlay";
import { UploadOutlined } from "@ant-design/icons";
import "./Styles/Job-Media&Finalize.css";
import { message } from "antd";
// import apiClient from "../api/clients";
// import { ENDPOINTS } from "../api/endpoints";

export default function MediaFinalize() {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { jobEdit } = location.state || {};
  const { jobData, updateJobData, submitJobData } = useJobCreation();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [image, setImage] = useState(null);
  const fileInputRef = useRef();

  useEffect(() => {
    return () => {
      if (previewUrl && typeof previewUrl === "string") {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [previewUrl]);

  // Only run once on mount to initialize the image from context
  useEffect(() => {
    const image = jobData.media?.image;

    if (image) {
      if (typeof image === "string") {
        setPreviewUrl(image);
        setImage(image);
      } else if (typeof image === "object") {
        const objectUrl = URL.createObjectURL(image);
        setPreviewUrl(objectUrl);
        setImage(image);
        return () => URL.revokeObjectURL(objectUrl);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file && file.size <= 2 * 1024 * 1024) {
      const objectUrl = URL.createObjectURL(file);
      setImage(file);
      setPreviewUrl(objectUrl);
      updateJobData("media", { image: file });
    } else {
      alert("Image must be under 2MB (png or jpeg)");
    }
  };

  //   const handleUseCompanyLogo = async () => {
  //     try {
  //       const userId = localStorage.getItem("jobUserId"); // Or however you store user ID
  //       if (!userId) return message.error("User ID not found");

  //       const response = await apiClient.get(ENDPOINTS.USER.USER_PROFILE(userId));
  //       const logoUrl = response?.data?.data?.company_logo;

  //       if (logoUrl) {
  //         setImage(logoUrl);
  //         setPreviewUrl(logoUrl);
  //         updateJobData("media", { image: logoUrl });
  //         message.success("Company logo successfully updated.");
  //       } else {
  //         message.warning("No company logo found in your profile.");
  //       }
  //     } catch (error) {
  //       console.error("Error fetching profile:", error);
  //       message.error("Failed to load company logo.");
  //     }
  //   };

  const handlePreview = () => {
    setIsModalOpen(true);
  };

  const handlePublish = async () => {
    setIsLoading(true);

    try {
      let finalJobData = { ...jobData };

      // ✅ If editing and image is still a URL (unchanged), remove it
      if (jobEdit && typeof image === "string") {
        finalJobData = { ...finalJobData, media: {} };
      }

      // ✅ If creating but image is missing, let backend add logo automatically
      if (!jobEdit && !image) {
        finalJobData = { ...finalJobData, media: {} };
      }

      await submitJobData(finalJobData);

      message.success(
        jobData.id ? "Job Edited Successfully!" : "Job Created Successfully!"
      );
      navigate("/jobs/job-admin/job-posts");
    } catch (error) {
      message.error("Error Publishing Job: " + error.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading && (
        <CreateJobLoadingOverlay
          image="https://res.cloudinary.com/diomlp95m/image/upload/v1752735823/Youthplus_Logoo_pjfjku.jpg"
          message="Publishing Job..."
        />
      )}
      <div className="media-header">
        <h2 className="media-header-title">Media & Finalize</h2>
      </div>
      <div className="media-finalize-page">
        <div className="job-upload-section">
          <div
            className="job-upload-box"
            onClick={() => fileInputRef.current.click()}
          >
            {image ? (
              <>
                <img
                  src={previewUrl}
                  alt="Uploaded"
                  className="job-uploaded-image"
                />
                {typeof image === "string" && (
                  <p className="job-upload-note"></p>
                )}
              </>
            ) : (
              <>
                <UploadOutlined className="job-upload-icon" />
                <p className="job-upload-note">Upload Image</p>
              </>
            )}

            <input
              type="file"
              accept="image/png, image/jpeg"
              ref={fileInputRef}
              onChange={handleImageUpload}
              style={{ display: "none" }}
            />
          </div>
          <div className="job-upload-text">
            <p className="job-upload-title">Upload Company/Job image</p>
            <p className="job-upload-note">
              (format: png or jpeg, max size: 2mb)
            </p>
            <p className="job-upload-note">
              If an image is not uploaded the default company logo will be used
            </p>
          </div>
        </div>
        {/* <div className="job-upload-buttons">
            <button
                type="job-button"
                className="job-upload-btn secondary"
                // onClick={}
            >
                Use Company Logo
            </button>
            <button
                type="button"
                className="job-upload-btn"
                onClick={() => fileInputRef.current.click()}
            >
                Upload Image
            </button>
        </div> */}
            
        </div>

        <JobButtons
            showPrevious={true}
            showPreview={true}
            showNext={false}
            previewText="Preview Job Post"
            onPreview={handlePreview}
        />
        <PreviewJobModal
            isOpen={isModalOpen}
            onClose={setIsModalOpen.bind(null, false)}
            jobData={jobData}
            onPublish={handlePublish}
        />
    </>
    );
}
